import React from 'react';

import { Checkbox } from '@mantine/core';

import type { SequenceData } from '../../types';

interface SequenceSelectHeaderProps {
  clonotypeId: number;
  sequences: SequenceData[];
  isSequenceSelected: (clonotypeId: number, sequenceId: string) => boolean;
  onSequenceToggle: (clonotypeId: number, sequenceId: string) => void;
}

/** Select-all checkbox for all sequences within a single clonotype. */
export function SequenceSelectHeader({ clonotypeId, sequences, isSequenceSelected, onSequenceToggle }: SequenceSelectHeaderProps) {
  const allSel = sequences.every((seq) => isSequenceSelected(clonotypeId, seq.metadata.sequenceId));
  const someSel = sequences.some((seq) => isSequenceSelected(clonotypeId, seq.metadata.sequenceId));
  return (
    <Checkbox
      checked={allSel}
      indeterminate={someSel && !allSel}
      onChange={() => {
        for (const seq of sequences) {
          if (allSel || !isSequenceSelected(clonotypeId, seq.metadata.sequenceId)) {
            onSequenceToggle(clonotypeId, seq.metadata.sequenceId);
          }
        }
      }}
      size="xs"
      color="#0064B0"
      aria-label="Select all sequences"
    />
  );
}

interface SequenceSelectCellProps {
  clonotypeId: number;
  sequenceId: string;
  isSequenceSelected: (clonotypeId: number, sequenceId: string) => boolean;
  onSequenceToggle: (clonotypeId: number, sequenceId: string) => void;
}

/** Per-sequence selection checkbox in the inner table. */
export function SequenceSelectCell({ clonotypeId, sequenceId, isSequenceSelected, onSequenceToggle }: SequenceSelectCellProps) {
  return (
    <Checkbox checked={isSequenceSelected(clonotypeId, sequenceId)} onChange={() => onSequenceToggle(clonotypeId, sequenceId)} size="xs" color="#0064B0" />
  );
}
